<template>
  <v-container>
    <h1>Logs</h1>
    <v-row>
      <v-col cols="3">
        <v-select
          attach
          :items="logLevels"
          label="Log Level"
          v-model="logLevel"
          @change="onLogLevelChanged"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xl="3" lg="3" md="6" sm="12">
        <v-select
          attach
          chips
          deletable-chips
          :items="applications"
          label="Users"
          multiple
          v-model="filter.applications"
          @change="onUsersChanged"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleApplications">
              <v-list-item-action>
                <v-icon>
                  {{ iconApplications }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ applicationsMessage }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="6" sm="12">
        <v-select
          attach
          chips
          deletable-chips
          :items="levels"
          label="Level"
          multiple
          v-model="filter.levels"
          @change="onLevelsChanged"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleLevels">
              <v-list-item-action>
                <v-icon>
                  {{ iconLevels }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ levelsMessage }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="9" sm="12">
        <v-select
          attach
          chips
          deletable-chips
          :items="loggers"
          label="Logger"
          multiple
          v-model="filter.loggers"
          @change="onLoggersChanged"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleLoggers">
              <v-list-item-action>
                <v-icon>
                  {{ iconLoggers }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ loggersMessage }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="3" sm="12" class="button">
        <v-btn outlined @click="onClear">
          <v-icon left>mdi-close-octagon-outline</v-icon>Clear Filters
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :group-by="groupBy"
          :headers="headers"
          :items-per-page="filter.itemsPerPage"
          :items="logs"
          item-key="id"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
          }"
          show-group-by
        >
          <template v-slot:[`item.detail`]="{ item }">
            <div>
              <v-btn outlined color="success" @click="onView(item.id)">
                <v-icon left>mdi-book-open</v-icon>Details
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LogService from "@/_services/api/log-service";
import router from '@/router'
import store from "@/store";

export default {
  name: "log-list",

  created() {
    LogService.getUsers().then((result) => {
      this.applications = result;
    });
    LogService.getLevels().then((result) => {
      this.levels = result;
    });
    LogService.getLoggers().then((result) => {
      this.loggers = result;
    });
    LogService.getLogLevel().then((result) => {
      this.logLevel = result;
    });

    this.filter.applications = store.getters.getLogSelectedUsers;
    this.filter.levels = store.getters.getLogSelectedLevels;
    this.filter.loggers = store.getters.getLogSelectedLoggers;

    console.log("Users: ", this.filter.applications);
    console.log("Levels: ", this.filter.levels);
    console.log("Loggers: ", this.filter.loggers);
    this.fetch();
  },

  computed: {
    iconApplications() {
      if (this.likesAllApplications) return "mdi-close-box";
      if (this.likesSomeApplications) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllApplications() {
      return this.filter.applications.length === this.applications.length;
    },
    likesSomeApplications() {
      return this.filter.applications.length > 0 && !this.likesAllApplications;
    },

    iconLevels() {
      if (this.likesAllLevels) return "mdi-close-box";
      if (this.likesSomeLevels) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllLevels() {
      return this.filter.levels.length === this.levels.length;
    },
    likesSomeLevels() {
      return this.filter.levels.length > 0 && !this.likesAllLevels;
    },

    iconLoggers() {
      if (this.likesAllLoggers) return "mdi-close-box";
      if (this.likesSomeLoggers) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllLoggers() {
      return this.filter.loggers.length === this.loggers.length;
    },
    likesSomeLoggers() {
      return this.filter.loggers.length > 0 && !this.likesAllLoggers;
    },
  },

  data: () => ({
    applications: [],
    applicationsMessage: "Select All",
    levelsMessage: "Select All",
    loggersMessage: "Select All",
    filter: {
      applications: [],
      levels: [],
      loggers: [],
      itemsPerPage: 10,
      page: 1,
    },
    groupBy: [],
    headers: [
      {
        text: "Detail",
        align: "start",
        groupable: false,
        sortable: false,
        value: "detail",
      },
      {
        text: "Logged",
        align: "start",
        groupable: false,
        sortable: true,
        value: "logged",
      },
      {
        text: "Level",
        align: "start",
        groupable: true,
        sortable: true,
        value: "level",
      },
      {
        text: "User",
        align: "start",
        groupable: true,
        sortable: true,
        value: "application",
      },
      {
        text: "Logger",
        align: "start",
        groupable: true,
        sortable: true,
        value: "logger",
      },
      {
        text: "Message",
        align: "start",
        groupable: false,
        sortable: false,
        value: "message",
      },
    ],
    levels: [],
    loggers: [],
    logs: [],
    logLevel: "",
    logLevels: ["Off", "Trace", "Debug", "Warn", "Info", "Error", "Fatal"],
    rowsPerPageItems: [10, 25, 50, 100],
  }),

  methods: {
    fetch() {
      LogService.get(this.filter).then((result) => {
        this.logs = result;
      });
    },

    onUsersChanged() {
      store.commit("setLogSelectedUsers", this.filter.applications);
      this.fetch();
    },

    onClear() {
      this.filter.applications = [];
      this.filter.levels = [];
      this.filter.loggers = [];
      
      store.commit("setLogSelectedUsers", this.filter.applications);
      store.commit("setLogSelectedLevels", this.filter.levels);
      store.commit("setLogSelectedLoggers", this.filter.logger);
      
      this.fetch();
    },

    onLogLevelChanged() {
      LogService.setLogLevel(this.logLevel).then((result) => {
        console.log("setLogLevel() ", result);
      });
    },

    onLevelsChanged() {
      store.commit("setLogSelectedLevels", this.filter.levels);
      this.fetch();
    },

    onLoggersChanged() {
      store.commit("setLogSelectedLoggers", this.filter.loggers);
      this.fetch();
    },

    toggleApplications() {
      this.$nextTick(() => {
        if (this.likesAllApplications) {
          this.filter.applications = [];
          this.applicationsMessage = "Select All"
        } else {
          this.filter.applications = this.applications.slice();
          this.applicationsMessage = "Unselect All"
        }

        this.onUsersChanged();
      });
    },
    toggleLevels() {
      this.$nextTick(() => {
        if (this.likesAllLevels) {
          this.filter.levels = [];
          this.levelsMessage = "Select All"
        } else {
          this.filter.levels = this.levels.slice();
          this.levelsMessage = "Unselect All"
        }

        this.onLevelsChanged();
      });
    },
    toggleLoggers() {
      this.$nextTick(() => {
        if (this.likesAllLoggers) {
          this.filter.loggers = [];
          this.loggersMessage = "Select All"
        } else {
          this.filter.loggers = this.loggers.slice();
          this.loggersMessage = "Unselect All"
        }

        this.onLoggersChanged();
      });
    },

    onView(id) {
      router.push("/setting/log/detail/" + id);
    },
  },

  router,
};
</script>

<style lang="scss" scoped>
.button {
  padding-top: 35px;
}
</style>
